module.exports = __webpack_public_path__ + "img/logo7.77370199.png";